import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import WebapiCommon from '@common/util/webapi.common';
import { getOrdenacaoKanban, getUsuarioLocalStorage, setOrdenacaoKanban } from '../../../localStorage.util';
import ImunologiaKanbanPage from './imunologia.kanban.page';
import TemplateHtmlItemKanban from '../../histologia/common/templateHtmlItemKanban';
import CommonFunctions from '@common/util/functions.common';
import * as commonActions from '@common/common.action';
import * as kanbanActions from '../../../componentes/dragdrog/store/kanban.action';
import * as organizarActions from '../../../componentes/dragdrog/organizarLote/store/organizar.action';
import Preview from '@componentes/PreviewURL';
import { quadroKanbanEnum, colorsSystem } from '@common/util/defaultValues';
import IntlMessage from "../../../helpers/intlMessage";
import { changePeriod, getDate, obterListagemDePeriodos, validarData } from '../../../helpers';

class ImunologiaLaminasContainer extends Component {
  constructor(props) {
    super(props);
    this.usuarioLocal = getUsuarioLocalStorage();
    this.numeroDoExameRef = React.createRef();
    const periodo = CommonFunctions.getPeriodosSubDays(0);

    this.state = {
      pendentesCount: 0,
      executandoCount: 0,
      concluidasCount: 0,
      showModalImprimirEtiquetaEmLote: false,
      laminasParaEtiqueta: [],
      laminaIndividualParaEtiqueta: [],
      modalOpenNaoConfor: false,
      itemInModal: null,
      naoconformidades: [],
      periodoInicial: periodo.periodoInicial,
			periodoFinal: periodo.periodoInicial,
      numeroDoExame: '',
      numeroDoPedido: '',
      laudoPesquisa: '',
      listaKanbam: [],
      patologistas: [],
      patologista: null,
      tecnicos: [],
      tecnicoSelecionado: null,
      mudou: false,
      show: false,
      url: '',
      periodo: { value: 'hoje', label: `${this.props.intl.formatMessage({ id: "period.today" })}` },
			periodos: [],
      sortAsc : getOrdenacaoKanban()
    };

    this.getDate = getDate.bind(this);
		this.changePeriod = changePeriod.bind(this);
    this.obterListagemDePeriodos = obterListagemDePeriodos.bind(this);
    this.validarData = validarData.bind(this);
		this.periodoAlterado(this.state.periodo);
  }

  limparFiltro() {
    this.setState({
      periodoInicial: null,
      periodoFinal: null,
      periodo: '',
      tecnicoSelecionado: null,
      numeroDoExame: '',
      numeroDoPedido: '',
      laudoPesquisa: '',
      listaKanbam: [],
      sortAsc : false
    });
  }

  render() {
    let etiquetaEmLoteComponentProps = {
      showModalImprimirEtiquetaEmLote: this.state
        .showModalImprimirEtiquetaEmLote,
      toggleModalImprimirEtiquetaEmLote: this.toggleModalImprimirEtiquetaEmLote.bind(
        this
      ),
      imprimirEtiquetaEmLote: this.imprimirEtiquetaEmLote.bind(this),
      laminasParaEtiqueta: this.state.laminasParaEtiqueta
    };

    let nConformidadeContainerProps = {
      modalOpenNaoConfor: this.state.modalOpenNaoConfor,
      toggleModalNaoConfor: this.toggleModalNaoConfor.bind(this),
      itemInModal: this.state.itemInModal,
      naoconformidades: this.state.naoconformidades,
      usuarioLocal: this.usuarioLocal,
      callBackConclusaoInclusaoResolucaoNConformidade: this.callBackConclusaoInclusaoResolucaoNConformidade.bind(
        this
      )
    };

    let imunologiaFiltroPageProps = {
      limparFiltro: this.limparFiltro.bind(this),
      tecnicos: this.state.tecnicos,
      tecnicoSelecionado: this.state.tecnicoSelecionado,
      periodoInicial: this.state.periodoInicial,
      periodoFinal: this.state.periodoFinal,
      onChangeData: this.onChangeData.bind(this),
      onChangeTecnico: this.onChangeTecnico.bind(this),
      onChangeNumeroExame: this.onChangeNumeroExame.bind(this),
      onChangeLaudo: this.onChangeLaudo.bind(this),
      onKeyPressNumeroExame: this.onKeyPressNumeroExame.bind(this),
      onKeyPressLaudo: this.onKeyPressLaudo.bind(this),
      numeroDoExame: this.state.numeroDoExame,
      numeroDoExameRef: this.numeroDoExameRef,
      laudoPesquisa: this.state.laudoPesquisa,
      buscar: this.buscar.bind(this),
      organizar: this.organizar.bind(this),
      periodos: this.state.periodos,
      periodo: this.state.periodo,
      onChangePeriodo: this.periodoAlterado.bind(this),
      mudarIntervaloPeriodo: this.mudarIntervaloPeriodo.bind(this),
      onKeyPressData: this.eventoOnKeyPressData.bind(this),
      onClickOrdem: this.onClickOrdem.bind(this),
      sortAsc: this.state.sortAsc,
      numeroDoPedido: this.state.numeroDoPedido,
      onChangeNumeroPedido: this.onChangeNumeroPedido.bind(this),
      onKeyPressNumeroPedido: this.onKeyPressNumeroPedido.bind(this),
    };

    let dragDropComponente = {
      listaKanbam: this.state.listaKanbam,
      onDragEndOverride: this.onDragEndOverride.bind(this),
      alturaKanbam: window.innerHeight - 191 + 'px'
    };

    return (
      <div>
        <Preview
          show={this.state.show}
          setShow={this.setShow.bind(this)}
          url={this.state.url}
        />
        <ImunologiaKanbanPage
          etiquetaEmLoteComponentProps={etiquetaEmLoteComponentProps}
          nConformidadeContainerProps={nConformidadeContainerProps}
          imunologiaFiltroPageProps={imunologiaFiltroPageProps}
          dragDropComponente={dragDropComponente}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.commonActions.showFadeCarregando(true);
    Promise.all([
      WebapiCommon.getUsuarioTecnicoDaHistologia(),
      WebapiCommon.getMedicos(),
      WebapiCommon.getNaoConformidades(),
      WebapiCommon.listarComplemento('CITOLOGIA_TECNICA'),
      WebapiCommon.getConfiguracaoMapaMacroscopico()
    ]).then(res => {
      let state = { ...this.state };
      state.tecnicos = [{ value: null, label: <IntlMessage id='dashboards.cytology.technical' /> }, ...res[0]];
      state.tecnicoSelecionado = { value: null, label: <IntlMessage id='dashboards.cytology.technical' /> };
      state.patologistas = res[1];
      state.naoconformidades = res[2];
      state.complementos = res[3];

      let configMacro = res[4];
      if (configMacro) {
        let medicoPadrao = configMacro.configuracoesMapaMacroscopicoItems.find(
          el => el.coluna === 'Cd_med_padrao_macro'
        );

        if (medicoPadrao) {
          this.props.commonActions.medicoPadraoMacroscopia(medicoPadrao.valor);
        }
      }

      this.setState(state);

      this.filtrar(
        null,
        state.periodoInicial,
        state.periodoFinal,
        state.numeroDoExame,
        state.laudoPesquisa,
        state.numeroDoPedido,
        state.sortAsc
      );
    });

    this.setState({periodos: this.obterListagemDePeriodos(this.props.intl)});
  }

  componentDidUpdate(prevProps, prevState) {
		if (this.state.sortAsc !== prevState.sortAsc) {
      setOrdenacaoKanban(this.state.sortAsc);
		  this.buscar();
		}

    if (this.state.mudou) {
      this.setState({ mudou: false });
      this.buscar();
    }

    if (this.props.novasLaminas) {
      this.props.kanbanActions.atualizarNovasLaminas(false);
      let data = CommonFunctions.getPeriodosSubDays();
      this.setState({
        periodoInicial: data.periodoInicial,
        periodoFinal: data.periodoFinal,
        mudou: true
      });
    }
    if (this.props.organizarLotenovasLaminas) {
      this.props.organizarActions.atualizarNovasLaminas(false);
      this.props.commonActions.showFadeCarregando(true);
      let data = CommonFunctions.getPeriodosSubDays();
      this.setState({
        periodoInicial: data.periodoInicial,
        periodoFinal: data.periodoFinal,
        mudou: true
      });
    }
  }

	resetarPeriodo = () => {
		this.setState({periodo: '', periodoInicial: null, periodoFinal: null})
	}

	periodoAlterado = (e) => {
		if (!e || !e.value) {
		  return this.resetarPeriodo();
		}

		let payload = this.getDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

		this.setState({
			periodo: e,
			periodoInicial: payload.dtinicial,
			periodoFinal: payload.dtfinal})
	}

	mudarIntervaloPeriodo = (val) => {
		let payload = this.changePeriod(val);

		this.setState({
			periodoInicial: payload.start,
			periodoFinal: payload.end})
	}

	eventoOnKeyPressData(event) {
		if (event.key === "Enter")
			this.buscar();
	}

  onClickOrdem() {
		this.setState({sortAsc: !this.state.sortAsc});
	}

  buscar() {
    if ((!this.state.tecnicoSelecionado || this.state.tecnicoSelecionado.value == null) &&
			this.state.numeroDoExame == '' &&
			this.state.laudoPesquisa == '' &&
      this.state.numeroDoPedido == '' &&
			((this.state.periodoInicial == null) || this.state.periodoInicial == '') &&
			((this.state.periodoFinal == null) || this.state.periodoFinal == '')) {
				this.props.commonActions.showAlerta('alerta', this.props.intl.formatMessage({id: 'dashboards.general.noFilteredItems'}), 3000);
			return;
		}

    let executarValidacaoDeData =
			((this.state.periodoInicial != null) && this.state.periodoInicial != '') ||
			((this.state.periodoFinal != null) && this.state.periodoFinal != '');
		let datasValidas = !executarValidacaoDeData ? true :
			this.validarData(this.state.periodoInicial, this.state.periodoFinal, this.props.intl, this.props.commonActions);

    if (datasValidas) {
      this.props.commonActions.showFadeCarregando(true);
      this.filtrar(
        this.state.tecnicoSelecionado && this.state.tecnicoSelecionado.value,
        this.state.periodoInicial,
        this.state.periodoFinal,
        this.state.numeroDoExame,
        this.state.laudoPesquisa,
        this.state.numeroDoPedido,
        this.state.sortAsc
      );
    }
  }

  organizar() {
    this.props.organizarActions.atualizarModal(true);
  }

  toggleModalImprimirEtiquetaEmLote = () =>
    this.setState(state => ({
      showModalImprimirEtiquetaEmLote: !state.showModalImprimirEtiquetaEmLote
    }));

  imprimirEtiquetaEmLote(laminasMarcadas) {
    this.props.commonActions.showFadeCarregando(true);

    let laminas = [];

    laminasMarcadas.map(el => {
      let laminasParaEtiqueta = this.state.laminasParaEtiqueta;
      let lamina = laminasParaEtiqueta.find(la => la.idLamina === el);

      laminas.push({
        impressora: 'clawPDF',
        codigoBarra: lamina.lamina,
        numeroExame: lamina.lamina,
        numeroExameExterno: lamina.numeroExameExterno,
        nomePaciente: lamina.nomePaciente,
        anticorpo: lamina.anticorpo,
        modelo: 'imuno',
        numeroPedido: lamina.numeroPedido.toString()
      });

      return lamina;
    });

    WebapiCommon.imprimirEtiquetaAreaTecnica(laminas, 'imuno').then(data => {
      var url = CommonFunctions.getPdfBlob(data.pdf);
      this.props.commonActions.showFadeCarregando(false);
      this.setState({ url: url });
      this.setShow(!this.state.show);
    });
  }

  setShow(show) {
    this.setState({ show });

    if (!show && this.state.showModalImprimirEtiquetaEmLote) {
      this.toggleModalImprimirEtiquetaEmLote();
    }
  }

  imprimirEtiquetaIndividual(item) {
    this.props.commonActions.showFadeCarregando(true);

    let etiquetas = [];

    etiquetas.push({
      impressora: 'clawPDF',
      codigoBarra: item.dsCasoLamina,
      numeroExame: item.dsCasoLamina,
      numeroExameExterno: item.numeroExameExterno,
      nomePaciente: item.nomePaciente,
      anticorpo: item.anticorpo,
      modelo: 'imuno',
      numeroPedido: item.numeroPedido.toString()
    });

    WebapiCommon.imprimirEtiquetaAreaTecnica(etiquetas, 'imuno').then(data => {
      var url = CommonFunctions.getPdfBlob(data.pdf);
      this.props.commonActions.showFadeCarregando(false);
      this.setState({ url: url });
      this.setShow(!this.state.show);
    });
  }

  toggleModalNaoConfor = () =>
    this.setState(state => ({
      modalOpenNaoConfor: !state.modalOpenNaoConfor
    }));

  openModalNaoConformidade(lamina) {
    let coluna = '';
    coluna = lamina.nmTabela === 'LAUDOLAMINAS' ? 'laudo_lamina' : coluna;
    coluna = lamina.nmTabela === 'LAUDOBLOCOSLAMINAS' ? 'bloco_lamina' : coluna;

    this.setState({
      itemInModal: {
        id: lamina.idExterno,
        label: lamina.lamina,
        etapa: 3,
        idExame: lamina.idExame,
        idLaudo: lamina.laudo,
        coluna
      }
    });

    this.toggleModalNaoConfor();
  }

  callBackConclusaoInclusaoResolucaoNConformidade() {
    let state = { ...this.state };
    this.props.commonActions.showFadeCarregando(true);
    let tecnico = !!state.tecnicoSelecionado
      ? state.tecnicoSelecionado.value
      : null;

    this.filtrar(
      tecnico,
      state.periodoInicial,
      state.periodoFinal,
      state.numeroDoExame,
      state.laudoPesquisa,
      state.numeroDoPedido,
      state.sortAsc
    );
  }

  filtrar(tecnico, dataInicial, dataFinal, numeroDoExame, laudoPesquisa, numeroDoPedido, sortAsc) {
    WebapiCommon.obterRequisicaoImunoCardLaminas(
      tecnico,
      dataInicial,
      dataFinal,
      numeroDoExame,
      laudoPesquisa,
      numeroDoPedido,
      sortAsc
    ).then(res => {
      let { listaKanbam } = this.state;

      let pendentes = res
        .filter(el => el.finalizacao === 'Pendente')
        .map(el => this.criarItemKanbam(el, 'pendente'));

      let executando = res
        .filter(el => el.finalizacao === 'Em andamento')
        .map(el => this.criarItemKanbam(el, 'executando'));

      let concluidas = res
        .filter(el => el.finalizacao === 'Finalizado')
        .map(el => this.criarItemKanbam(el, 'laminas'));

      listaKanbam = this.getKanbam(pendentes, executando, concluidas);

      let laminasParaEtiqueta = res.map(el => ({
        finalizacao: el.finalizacao,
        idLamina: el.idlamina,
        lamina: el.dsCasoLamina,
        numeroExameExterno: el.numeroExameExterno,
        nomePaciente: el.nomePaciente,
        anticorpo: el.anticorpo,
        modelo: 'imuno',
        numeroPedido: el.numeroPedido
      }));

      this.setState({
        listaKanbam,
        laminasParaEtiqueta
      });

      this.props.commonActions.showFadeCarregando(false);
      this.numeroDoExameRef.current.focus();

      if (res.length === 0) {
        this.props.commonActions.showAlerta(
          'alerta',
          <IntlMessage id="dashboards.reports.noResultsFound" />,
          1500
        );
      }
    });
  }

  criarItemKanbam(lamina, etapa) {
    let id = `lamina_${lamina.idlamina}_${etapa}_${lamina.cdRequisicao}`;
    let content = TemplateHtmlItemKanban(
      lamina,
      this.imprimirEtiquetaIndividual.bind(this),
      () => { },
      this.openModalNaoConformidade.bind(this)
    );

    return {
      id: id,
      data: lamina,
      isDragDisabled: lamina.existeNConformidade === 1,
      content
    };
  }

  getKanbam(pendente, executando, concluidas) {
    this.setState({
      pendentesCount: pendente.length,
      executandoCount: executando.length,
      concluidasCount: concluidas.length
    });
    return [
      {
        pendente: pendente,
        title: {
          text: `${this.props.intl.formatMessage({ id: "dashboards.cytology.danglingBlades" })}`,
          color: colorsSystem.DG2
        },
        count: this.state.pendentesCount
      },
      {
        executando: executando,
        title: {
          text: `${this.props.intl.formatMessage({ id: "dashboards.cytology.bladesInProgress" })}`,
          color: colorsSystem.DG3
        },
        count: this.state.executandoCount
      },
      {
        concluidas: concluidas,
        title: {
          text: `${this.props.intl.formatMessage({ id: "dashboards.cytology.bladesReady" })}`,
          color: colorsSystem.DG5
        },
        count: this.state.concluidasCount
      }
    ];
  }

  obterPeriodoFiltroInicializacao() {
    return CommonFunctions.getPeriodosSubDays();
  }

  onChangeData(name, value) {
    let state = { ...this.state };

    state[name] = value;
    this.setState(state);

    if (!value) {
      this.setState({ [name]: value });
    }
  }

  onChangeTecnico(tecnico) {
    let state = { ...this.state };
    state.tecnicoSelecionado = tecnico;
    this.setState(state);
    // this.props.commonActions.showFadeCarregando(true);
    // this.filtrar(
    //   state.tecnicoSelecionado.value,
    //   state.periodoInicial,
    //   state.periodoFinal,
    //   state.numeroDoExame,
    //   state.laudoPesquisa
    // );
  }

  onChangeNumeroExame(event) {
    this.setState({
      numeroDoExame: event.currentTarget.value
    });
  }

  onChangeNumeroPedido(event) {
    this.setState({
      numeroDoPedido: event.currentTarget.value
    });
  }

  onChangeLaudo(event) {
    this.setState({
      laudoPesquisa: event.currentTarget.value
    });
  }

  onKeyPressNumeroExame(event) {
    if (event.key === 'Enter') {
      let {
        periodoInicial,
        periodoFinal,
        tecnicoSelecionado,
        numeroDoExame,
        laudoPesquisa,
        numeroDoPedido,
        sortAsc
      } = this.state;

      let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
      this.props.commonActions.showFadeCarregando(true);
      this.filtrar(
        tecnico,
        periodoInicial,
        periodoFinal,
        numeroDoExame,
        laudoPesquisa,
        numeroDoPedido,
        sortAsc
      );
    }
  }

  onKeyPressNumeroPedido(event) {
    if (event.key === 'Enter') {
      let {
        periodoInicial,
        periodoFinal,
        tecnicoSelecionado,
        numeroDoExame,
        laudoPesquisa,
        numeroDoPedido,
        sortAsc
      } = this.state;

      let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
      this.props.commonActions.showFadeCarregando(true);
      this.filtrar(
        tecnico,
        periodoInicial,
        periodoFinal,
        numeroDoExame,
        laudoPesquisa,
        numeroDoPedido,
        sortAsc
      );
    }
  }

  onKeyPressLaudo(event) {
    if (event.key === 'Enter') {
      let {
        periodoInicial,
        periodoFinal,
        tecnicoSelecionado,
        numeroDoExame,
        laudoPesquisa,
        numeroDoPedido,
        sortAsc
      } = this.state;

      let tecnico = !!tecnicoSelecionado ? tecnicoSelecionado.value : null;
      this.props.commonActions.showFadeCarregando(true);
      this.filtrar(
        tecnico,
        periodoInicial,
        periodoFinal,
        numeroDoExame,
        laudoPesquisa,
        numeroDoPedido,
        sortAsc
      );
    }
  }

  onDragEndOverride(result) {
    const { source, destination } = result;

    var origem = {
      pendente: 0,
      executando: 1,
      concluidas: 2
    };

    let { listaKanbam } = this.state;

    let item =
      listaKanbam[origem[source.droppableId]][source.droppableId][source.index];
    let error =
      item.data.bloqueado === 'S'
        ? <IntlMessage id="dashboards.immunology.blockedImpedingNonconformity" />
        : '';

    error = !(source && destination) ? <IntlMessage id="dashboards.immunology.unexpectedErrorOccurred" /> : '';

    if (error === '') {
      this.move(source, destination);
    } else {
      this.props.commonActions.showAlerta('erro', error, 2000);
    }
  }

  move(source, destination) {
    let listaKanbam = cloneDeep(this.state.listaKanbam);
    let origem = listaKanbam.find(
      e => Object.keys(e)[0] === source.droppableId
    );
    let destino = listaKanbam.find(
      e => Object.keys(e)[0] === destination.droppableId
    );
    let movido = origem[source.droppableId].splice(source.index, 1)[0];

    let icone = quadroKanbanEnum.IM_PENDENTES.icone;
    icone =
      destination.droppableId === quadroKanbanEnum.IM_EXECUTANDO.id
        ? quadroKanbanEnum.IM_EXECUTANDO.icone
        : icone;
    icone =
      destination.droppableId === quadroKanbanEnum.IM_PRONTAS.id
        ? quadroKanbanEnum.IM_PRONTAS.icone
        : icone;

    let status = quadroKanbanEnum.IM_PENDENTES.status;
    status =
      destination.droppableId === quadroKanbanEnum.IM_EXECUTANDO.id
        ? quadroKanbanEnum.IM_EXECUTANDO.status
        : status;
    status =
      destination.droppableId === quadroKanbanEnum.IM_PRONTAS.id
        ? quadroKanbanEnum.IM_PRONTAS.status
        : status;

    WebapiCommon.atualizarStatusDaLamina(
      movido.data.idlamina,
      status,
      movido.data.cdRequisicao
    )
      .then(() => {
        destino[destination.droppableId].splice(
          destination.index,
          0,
          this.criarItemKanbam(movido.data, icone)
        );

        destino[destination.droppableId] = destino[
          destination.droppableId
        ].sort((a, b) => {
          return a.data.idLamina - b.data.idLamina;
        });

        listaKanbam[0].count = listaKanbam[0].pendente
          ? listaKanbam[0].pendente.length
          : 0;
        listaKanbam[1].count = listaKanbam[1].executando
          ? listaKanbam[1].executando.length
          : 0;
        listaKanbam[2].count = listaKanbam[2].concluidas
          ? listaKanbam[2].concluidas.length
          : 0;

        this.setState({
          listaKanbam: listaKanbam,
          pendentesCount: listaKanbam[0].pendente
            ? listaKanbam[0].pendente.length
            : 0,
          executandoCount: listaKanbam[1].executando
            ? listaKanbam[1].executando.length
            : 0,
          concluidasCount: listaKanbam[2].concluidas
            ? listaKanbam[2].concluidas.length
            : 0
        });

        console.log(`[PENDENTES]:${this.state.pendentesCount}`);
        console.log(`[EXECUTANDO]:${this.state.executandoCount}`);
        console.log(`[CONCLUIDOS]:${this.state.concluidasCount}`);

        this.props.commonActions.showAlerta(
          'sucesso',
          <IntlMessage id="dashboards.cytology.poweredBlades" />,
          800
        );
      })
      .catch(() => {
        this.props.commonActions.showAlerta(
          'erro',
          <IntlMessage id="dashboards.cytology.bladesNotMoved" />,
          1500
        );
      });
  }
}

const mapStateToProps = state => {
  return {
    medicoPadrao: state.commonReducer.medicoPadraoMacroscopia,
    novasLaminas: state.kanban.novasLaminas,
    organizarLotenovasLaminas: state.organizarLote.novasLaminas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    kanbanActions: bindActionCreators(kanbanActions, dispatch),
    organizarActions: bindActionCreators(organizarActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImunologiaLaminasContainer);



// WEBPACK FOOTER //
// ./src/pages/imunologia/content/imunologia.container.js